<div class="icon-container" *ngIf="hasIcon && icon">
  <nb-icon [config]="icon"></nb-icon>
</div>
<div class="content-container">
  <span class="title subtitle">{{ toast.title }}</span>
  <div class="message">{{ toast.message }}</div>
</div>
